module.exports = "/dist/assets/images/circlewithquestionmark.svg";